module.exports = __webpack_public_path__ + "img/ecoresponsabilidad.2173886d.png";